import { render, staticRenderFns } from "./WorkIconRevertArchived.vue?vue&type=template&id=7e78fee7"
import script from "./WorkIconRevertArchived.vue?vue&type=script&lang=js"
export * from "./WorkIconRevertArchived.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports